import React from 'react'
import httpservice from '../_service/httpservice';
interface LooseObject {
    [key: string]: any
}
const ModalDialog = (props: any) => {
    const [isProcessing, setIsProcessing] = React.useState(false);
    const handleModalDialogClose = (value: boolean) => {
        props.handleModalDialog(value)
    }
    const handleSubmit = async (event: any) => {
        event.preventDefault();
        if (!isProcessing) {
            setIsProcessing(true);
            var object: LooseObject = {};
            setIsProcessing(true);
            let formData = new FormData(event.currentTarget);
            formData.forEach((value, key) => object[key] = value);
            await httpservice.action.post("/Global/Quote", object);
            handleModalDialogClose(false);
            setIsProcessing(false);
        }
       
    };
    return (
        <div className="modal fades-in quote-modal show" id="exampleModal" tabIndex={-1}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="quote-title" id="exampleModalLabel">Get a Quote</h5>
                    </div>
                    <div className="modal-body">
                        <div className="row m-0 p-0">
                            <div className="col-lg-3 m-0 p-0">
                                <img onError={props.noImageHandling} src={props.item?.defaultImage?.image ?? "/img.png"} alt={props.item?.defaultImage?.title} />
                            </div>
                            <div className="col-lg-9 m-0 p-0">
                                <p className="product-tag d-inline-block mt-3 mb-0">Item SKU: {props.item?.itemSKU}</p>
                                <h5 className="product-name mx-0 mb-0 mt-2">{props.item?.itemTitle}</h5>
                            </div>
                        </div>
                    </div>
                    <div className="quote-footer">
                        <form action="" method="get" onSubmit={handleSubmit} className="form-example">
                            <input type="hidden" name="itemId" value={props.item?.itemID} />
                            <input type="hidden" name="itemTitle" value={props.item?.itemTitle } />
                            <input type="hidden" name="itemSKU" value={props.item?.itemSKU } />
                            <input type="hidden" name="imageUrl" value={props.item?.defaultImage?.image } />
                            <div className="form-example">
                                <label>Name* </label>
                                <input type="text" name="name" id="name" required />
                            </div>
                            <div className="form-example">
                                <label>Email Address*</label>
                                <input type="email" name="email" id="email" required />
                            </div>
                            <div className="form-example">
                                <label>Phone Number</label>
                                <input type="text" name="mobile" maxLength={12} id="mobile" required />
                            </div>
                            <div className="form-example">
                                <label>Subject*</label>
                                <input type="text" name="subject" id="subject" required />
                            </div>
                            <div className="form-example position-relative">
                                <label className="position-absolute message-box">Message</label>
                                <textarea name="message" id="message"></textarea>
                            </div>
                            <div className="form-example submit-box">
                                <button type="button" className="button btn-1" data-bs-dismiss="modal" onClick={() => { handleModalDialogClose(false) }}>Cancel</button>
                                <button type="submit" className="button  btn-2 ms-2">{isProcessing ? "Submiting..." : "Submit Request"}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ModalDialog